import { RouteObject } from "react-router-dom";
import { AnalyticsOverview } from "../pages/admin/analytics/AnalyticsOverview";

export const analyticsRoutes: RouteObject[] = [
  {
    id: "analytics-overview",
    index: true,
    element: <AnalyticsOverview />,
  },
];
